export const TitleSkeleton = () => {
  return (
    <div className="w-full animate-pulse delay-100 my-3">
      <div className="w-1/3 h-8 bg-gray-200 rounded"></div>
    </div>
  );
};
